import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import Loadingcomponent from '../loader/loadingcomponent';
import { useSelector } from 'react-redux';
import OutofInternetSwiper from './outof-internet-swiper';

const OutofInternet = ({ pmsitem }) => {
  const {
    userdata: { dashboardRecommendations },
  } = useSelector((state) => state);

  let _requetData = pmsitem?.sourceid
    .replace('!OFFERGROUP!', dashboardRecommendations?.recooffergroup)
    .replace('!RECOTYPE!', dashboardRecommendations?.recotype);

  const {
    data: { data } = {},
    isLoading,
    isFetching,
    isError,
    error,
    isLoadingError,
    refetch,
  } = useQuery(
    [pmsitem?.uniqueid, pmsitem?.method, JSON.parse(_requetData), {}],
    {
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      enabled: false,
    }
  );

  useEffect(() => {
    if (
      dashboardRecommendations &&
      dashboardRecommendations?.recooffergroup !== null &&
      dashboardRecommendations?.recotype !== null
    ) {
      refetch();
    }
    //eslint-disable-next-line
  }, [dashboardRecommendations]);

  if (!dashboardRecommendations) {
    return <></>;
  }

  if (isLoading || isFetching) {
    return <Loadingcomponent />;
  }
  console.log(data, "datadata")
  return (
 data ?  <div>
      <div className="flex_grp_between mb-3 mt-4">
        <div className="flex_grp_align_center flex1">
          <h3 className="section_title_light mb-0">
            {data ? dashboardRecommendations?.headding ?? '' : ''}
          </h3>
        </div>
      </div>
      <OutofInternetSwiper pmsitem={pmsitem} data={data} />
    </div > : <></>
  );
};

export default OutofInternet;
